export const appName = process.env.REACT_APP_WEB_NAME || "DEMO";
